import { render, staticRenderFns } from "./DPRenewal.vue?vue&type=template&id=04a847f0"
import script from "./DPRenewal.vue?vue&type=script&lang=js"
export * from "./DPRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports